// Components
import Radio from '@/components/common/livemallclub/Radio'

// Styles

// Variables

// PropTypes
const propTypes = {}

function Item(props) {
  return <Radio {...props} />
}

Item.propTypes = propTypes

export default Item
